var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1080 200",
    width: 1080,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36L25.7 34.8C51.3 33.7 102.7 31.3 154.2 31.5C205.7 31.7 257.3 34.3 308.8 33.5C360.3 32.7 411.7 28.3 463 26.3C514.3 24.3 565.7 24.7 617 26.8C668.3 29 719.7 33 771.2 35.2C822.7 37.3 874.3 37.7 925.8 38.5C977.3 39.3 1028.7 40.7 1054.3 41.3L1080 42L1080 0L1054.3 0C1028.7 0 977.3 0 925.8 0C874.3 0 822.7 0 771.2 0C719.7 0 668.3 0 617 0C565.7 0 514.3 0 463 0C411.7 0 360.3 0 308.8 0C257.3 0 205.7 0 154.2 0C102.7 0 51.3 0 25.7 0L0 0Z",
    fill: "#0486d4",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.ba1cb96f95eb112000f00464079f6a13.svg";
export { ForwardRef as ReactComponent };